/**
 * EVM address validation.
 *
 * Shape-only for now — EIP-55 checksum validation lives at the SDK
 * layer when there's an actual EVM consumer (viem's `isAddress` or
 * ethers' `utils.isAddress`). The on-curve concept doesn't apply
 * here: EVM uses secp256k1 + Keccak-256, and the visible 40-hex
 * address is derived from the public key hash rather than being a
 * curve point itself, so there's no equivalent of Solana's Tier 2.
 *
 * # Mirroring the Solana namespace shape
 *
 * Even though EVM only has `isShape` today, this stays exported as
 * an object so adding a future `isWallet` (e.g. with EIP-55 checksum
 * enforcement) or `fetchAccount` (RPC `eth_getCode` / `eth_getBalance`)
 * doesn't change the import shape at call sites.
 */

// `0x` + 40 hex chars. Case-insensitive — checksum validation is a
// separate concern that lives at the SDK layer.
const EVM_ADDRESS_RE = /^0x[a-fA-F0-9]{40}$/;

export const EvmAddress = {
    /** Shape — `0x` prefix + 40 hex chars. Case-insensitive. */
    isShape(address: string): boolean {
        const trimmed = (address ?? "").trim();
        return EVM_ADDRESS_RE.test(trimmed);
    }
} as const;
